import { Theme } from '@mui/material/styles'

import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()((theme: Theme) => ({
  last: {
    marginTop: `${theme.spacing(2.5)} !important`,
  },
  magnifyingGlass: {
    borderRadius: theme.spacing(0.5),
    backgroundColor: theme.palette.textBackground.main,
  },
  gridContainer: {
    marginBottom: `${theme.spacing(2)} !important`,
  },
  productContainer: {
    padding: theme.spacing(3, 3, 1, 3),
    backgroundColor: theme.palette.textBackground.light,
  },
  rowTitle: {
    color: theme.palette.textField.main,
    fontFamily: 'Poppins !important',
    fontWeight: 400,
    '& .MuiTypography-root': {
      fontWeight: '400 !important',
    },
    fontSize: `${theme.spacing(1.5)} !important`,
    height: `${theme.spacing(2)} !important`,
  },
  rowValue: {
    marginTop: `${theme.spacing(0.5)} !important`,
    height: `${theme.spacing(2.5)} !important`,
    fontFamily: 'Poppins !important',
    fontWeight: 400,
    '& .MuiTypography-root': {
      fontWeight: '400 !important',
    },
    fontSize: `${theme.spacing(1.75)} !important`,
  },
  rowHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    letterSpacing: '0.1px',
    fontFamily: 'Poppins !important',
    fontSize: theme.spacing(1.75),
    fontWeight: 500,
    margin: theme.spacing(3, 0, 3, 0),
    cursor: 'pointer',
  },
  divider: {
    height: theme.spacing(0.125),
    border: 0,
    borderColor: theme.palette.dividerV2.main,
    backgroundColor: theme.palette.dividerV2.main,
  },
  chevronIcon: {
    marginLeft: 'auto',
    transition: 'transform 0.2s ease-in-out',
    fontSize: '12px',
    color: theme.palette.text.secondary,
  },
}))
